<template>
  <div v-if="visible" class="loan-overlay" @click.self="handleClose">
    <div class="loan-container loan-dialog">
      <!-- 关闭按钮 -->
      <button class="close-btn" @click="handleClose">
        <i class="el-icon-close"></i>
      </button>
      
      <!-- 标题 -->
      <div class="loan-header">
        <h2 class="loan-title">{{ $t('loan.title') || '贷款' }}</h2>
      </div>
      
      <!-- 贷款内容 -->
      <div class="loan-content">
        <LoanPc />
      </div>
    </div>
  </div>
</template>

<script>
import LoanPc from '@/views/loan/components/loan_pc.vue';

export default {
  name: 'LoanDialog',
  components: {
    LoanPc
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false);
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
/* 遮罩层 */
.loan-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  transition: all 0.3s ease;
}

/* 容器 */
.loan-container {
  width: 900px;
  max-width: 95vw;
  max-height: 85vh;
  background: var(--card-bg);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  overflow-y: auto;
  position: relative;
  padding: 40px;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

/* 关闭按钮 */
.close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  background: var(--bg-secondary);
  color: var(--text-secondary);
  border: none;
  transition: all 0.3s ease;
  z-index: 10;
}

.close-btn:hover {
  background: var(--hover-bg);
  color: var(--text-primary);
}

.close-btn i {
  font-size: 18px;
}

/* 标题区域 */
.loan-header {
  margin-bottom: 30px;
}

.loan-title {
  font-size: 24px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
  transition: color 0.3s ease;
}

/* 贷款内容区域 - 移除loan_pc组件内部的wrapper背景和padding，使用外层容器的样式 */

/* 滚动条样式 */
.loan-container::-webkit-scrollbar {
  width: 6px;
}

.loan-container::-webkit-scrollbar-track {
  background: var(--bg-secondary);
  border-radius: 3px;
}

.loan-container::-webkit-scrollbar-thumb {
  background: var(--border-color);
  border-radius: 3px;
}

.loan-container::-webkit-scrollbar-thumb:hover {
  background: var(--text-tertiary);
}

/* 响应式 */
@media (max-width: 768px) {
  .loan-container {
    width: 95vw;
    padding: 20px;
  }
}
</style>

<!-- 全局样式：优化loan_pc组件在弹窗中的显示 -->
<style>
/* 移除loan_pc组件的wrapper背景和边距 */
.loan-dialog .loan_wrapper {
  background: transparent !important;
  min-height: auto !important;
  padding: 0 !important;
  margin: 0 !important;
}

.loan-dialog .loan_borrow {
  background: transparent !important;
  padding: 0 !important;
  margin: 0 !important;
}

/* 移除顶部导航栏（因为已经有弹窗标题了） */
.loan-dialog .nav_m {
  display: none !important;
}

/* 优化可借金额显示 */
.loan-dialog .money_value {
  font-size: 36px !important;
  font-weight: 700 !important;
  color: var(--text-primary) !important;
  margin-bottom: 10px;
}

.loan-dialog .ver_tips {
  color: var(--text-secondary) !important;
  font-size: 14px;
}

/* 优化贷款表单的卡片样式 - 圆角输入框 */
.loan-dialog .select_button {
  background: var(--bg-secondary) !important;
  border-radius: 12px !important;
  padding: 16px 20px !important;
  margin-bottom: 15px !important;
  /* ✅ 去除阴影和边框 */
  box-shadow: none !important;
  transition: all 0.3s ease !important;
}

.loan-dialog .select_button:hover {
  background: var(--hover-bg) !important;
}

/* 输入框样式 */
.loan-dialog .select_button input {
  background: transparent !important;
  color: var(--text-primary) !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  border: none !important;
  outline: none !important;
}

.loan-dialog .select_button input::placeholder {
  color: var(--text-secondary) !important;
}

/* 标签文字 */
.loan-dialog .select_button .label {
  color: var(--text-primary) !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  margin-right: 10px;
}

/* 选择器样式 - 圆角 */
.loan-dialog .select_button .select {
  background: var(--card-bg) !important;
  border-radius: 8px !important;
  padding: 8px 12px !important;
  color: var(--text-primary) !important;
  /* ✅ 去除边框 */
  transition: all 0.3s ease !important;
}

.loan-dialog .select_button .select:hover {
  background: var(--hover-bg) !important;
}

.loan-dialog .select_button .select span {
  color: var(--text-primary) !important;
  font-weight: 500 !important;
}

/* 下拉选项 - 圆角 */
.loan-dialog .select_button .select_options {
  background: var(--card-bg) !important;
  border-radius: 12px !important;
  /* ✅ 去除阴影和边框 */
  overflow: hidden !important;
  margin-top: 8px !important;
}

.loan-dialog .select_button .select_options .option {
  color: var(--text-primary) !important;
  padding: 12px 16px !important;
  transition: all 0.2s ease !important;
  cursor: pointer !important;
}

.loan-dialog .select_button .select_options .option:hover {
  background: var(--hover-bg) !important;
}

.loan-dialog .select_button .select_options .option.active {
  background: var(--primary-color-10) !important;
  color: var(--primary-color) !important;
  font-weight: 600 !important;
}

/* 信息展示区域 */
.loan-dialog .info_content {
  background: var(--bg-secondary) !important;
  border-radius: 12px !important;
  padding: 20px !important;
  margin: 20px 0 !important;
  /* ✅ 去除边框 */
}

.loan-dialog .info_content .info_item .title {
  color: var(--text-secondary) !important;
  font-size: 14px !important;
  margin-bottom: 5px;
}

.loan-dialog .info_content .info_item .content {
  color: var(--text-primary) !important;
  font-size: 18px !important;
  font-weight: 600 !important;
}

.loan-dialog .info_content .tips {
  color: var(--text-secondary) !important;
  font-size: 12px !important;
  margin-top: 10px;
}

/* 优化贷款记录区域 */
.loan-dialog .loan-records-section {
  background: var(--bg-secondary) !important;
  border-radius: 12px !important;
  padding: 20px !important;
  margin-top: 20px !important;
  /* ✅ 去除边框 */
}

.loan-dialog .loan-records-section .loan_title {
  color: var(--text-primary) !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  margin-bottom: 15px;
}

/* 记录卡片 */
.loan-dialog .collapse-content {
  /* ✅ 改为灰色背景 */
  background: var(--bg-secondary) !important;
  border-radius: 12px !important;
  /* ✅ 去除边框 */
  margin-bottom: 12px !important;
  transition: all 0.3s ease !important;
}

.loan-dialog .collapse-content:hover {
  background: var(--hover-bg) !important;
}

/* 优化按钮样式 - 圆角 */
.loan-dialog .button {
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
  font-weight: 600 !important;
  padding: 14px 28px !important;
  font-size: 16px !important;
}

.loan-dialog .button:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 16px var(--primary-color-20) !important;
}

.loan-dialog .button.black,
.loan-dialog .button.round,
.loan-dialog .button.yellow {
  background: var(--primary-color) !important;
  color: var(--text-on-primary) !important;
  border: none !important;
}

.loan-dialog .button.black:hover,
.loan-dialog .button.round:hover,
.loan-dialog .button.yellow:hover {
  background: var(--primary-dark) !important;
}

/* 箭头图标颜色 */
.loan-dialog .icon_arrow {
  filter: brightness(0) saturate(100%) invert(var(--icon-invert, 0));
}

/* 黑夜模式下的图标反色 */
.dark-mode .loan-dialog .icon_arrow {
  --icon-invert: 1;
}

/* ✅ 黑夜模式适配 */
.dark-mode .loan-dialog .select_button {
  background: rgba(255, 255, 255, 0.05) !important;
}

.dark-mode .loan-dialog .select_button:hover {
  background: rgba(255, 255, 255, 0.08) !important;
}

.dark-mode .loan-dialog .select_button .select {
  background: rgba(255, 255, 255, 0.05) !important;
}

.dark-mode .loan-dialog .select_button .select:hover {
  background: rgba(255, 255, 255, 0.1) !important;
}

.dark-mode .loan-dialog .select_button .select_options {
  background: rgba(255, 255, 255, 0.08) !important;
}

.dark-mode .loan-dialog .info_content {
  background: rgba(255, 255, 255, 0.05) !important;
}

.dark-mode .loan-dialog .loan-records-section {
  background: rgba(255, 255, 255, 0.05) !important;
}

.dark-mode .loan-dialog .collapse-content {
  background: rgba(255, 255, 255, 0.08) !important;
}

.dark-mode .loan-dialog .collapse-content:hover {
  background: rgba(255, 255, 255, 0.12) !important;
}
</style>
